import { useMemo } from "react";
import { useUser } from "src/business-types/grocery/components/UserContext";
import { PrintData } from "src/printConfigration/PrintConfigration";
import { OrderList } from "../../orders/types/orderTypes";

const useResPrintData = (order: OrderList | null) => {
  const { user } = useUser();

  const printData = useMemo<PrintData | null>(() => {
    if (!order || !user) return null;

    // Calculate amounts
    const finalAmount = Number(order.Finalamount || 0);
    const paidAmount = order.payments?.reduce((sum, p) => sum + (Number(p.ReceivedAmount) || 0), 0) || 0;

    // Transform products
    const products = (order.Products || []).map((product) => ({
      productName: product.productName || "",
      arabicword: product.arabicword || "",
      amount: Number(product.amount || 0),
      quantity: Number(product.quantity || 0),
      totalPrice: Number(product.totalPrice || 0),
      Type: product.Type || "",
    }));

    return {
      CustomerName: order.CustomerName || "",
      CustomerPhon: order.CustomerPhoneNo?.toString() || "",
      OrderId: order.Orderid || "",
      OrderStatus: order.OrderStatus || "",
      Date: order.Orderdate || "",
      Time: order.Ordertime || "",
      Products: products,
      Paid: paidAmount,
      unpaid: paidAmount ? 0 : order.RemainingAmount,
      Tip: order.Tip,
      total: Number(order.totalAmount || 0),
      subtotal: finalAmount,
      discount: Number(order.discount || 0),
      paymentMethod: order.payments?.map((p) => p.Paymentmethod).join(", ") || "",
      busnessName: user?.organization_name || "",
      busnessArabicName: user?.organization_arabic_name || "",
      businessLocation: user?.business_location || "",
      phoneNum: user?.phone_number || "",
      billNo: order.billNumber,
      deliveryFee: order.deliveryFee,
      OSB: paidAmount ? 0 : order.RemainingAmount,
    };
  }, [order, user]);

  return printData;
};

export default useResPrintData;
